import React, { useState } from 'react';
import { TextInput } from 'chic-ui';
import { Row } from 'react-bootstrap';

const Clearable = () => {
    const [value, setValue] = useState('');
  return (
    <>
      <h4 className="mt-5">Clearable</h4>
      <p>
        To clear the input, add the <i>clearable</i> prop and the <i>UseState</i> hook. The implementation is given below:
      </p>
      <div className="btn-group btns mt-3">
      <TextInput
        placeholder="Type and clearrr..."
        width="400px"
        value={value}
        onChange={(e) => setValue(e.currentTarget.value)}
        clearable
        />
     </div>
      <Row className="mt-3">
        <code>
          {'import React, { useState } from "react";'}
          <br />
          {'import { TextInput } from "chic-ui";'}
          <br />
          {'const [value, setValue] = useState("");'}
          <br />
          {'<TextInput placeholder="Type and clearrr..." width="400px" value={value} onChange={(e) => setValue(e.currentTarget.value)} clearable />'}
        </code>
      </Row>
    </>
  );
};

export default Clearable;
